module.exports = __webpack_public_path__ + "static/img/hero1_info.1147239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero1_info.png
// module id = bv7p
// module chunks = 1